import * as _ from "lodash";

import { Input, Select } from "@/components";
import { Map } from "@/utils";

import SettingsStep from "../Step";

const renderFormControls = ({ formState, changeFormState, FormControl }) => {
    const ceilingTypesOptions = _.map(
        Map.Collections.ceilingTypes,
        (positionType) => ({
            value: positionType,
            label: positionType,
        }),
    );

    const renderCeilingTileSizeSelect = () => {
        const tileSizesOptions = _.map(
            Map.Collections.tileSizes,
            (tileSize, name) => ({
                value: tileSize,
                label: name,
            }),
        );

        const { tileSizeX, tileSizeY } = formState;

        let selectedTileSize = _.find(tileSizesOptions, (tileSize) =>
            _.isEqual(tileSize.value, { tileSizeX, tileSizeY }),
        );

        if (!selectedTileSize) {
            selectedTileSize = tileSizesOptions[0];
        }

        return (
            <FormControl className="col-sm-4" name="tileSize">
                <label className="selectLabel">Ceiling Tile Size (feet)</label>
                <Select
                    searchable
                    value={selectedTileSize ? selectedTileSize.value : null}
                    options={tileSizesOptions}
                    onChange={({ value }) => !!value && changeFormState(value)}
                />
            </FormControl>
        );
    };

    const renderCeilingTileSizeCustom = () => {
        return [
            <FormControl className="col-sm-3" key={1} name="tileSizeX">
                <Input
                    value={formState.tileSizeX}
                    label="Custom X"
                    onChange={(value) =>
                        changeFormState({
                            tileSizeX: value,
                        })
                    }
                    type="number"
                />
            </FormControl>,
            <FormControl className="col-sm-3" key={2} name="tileSizeY">
                <Input
                    value={formState.tileSizeY}
                    label="Custom Y"
                    onChange={(value) =>
                        changeFormState({
                            tileSizeY: value,
                        })
                    }
                    type="number"
                />
            </FormControl>,
        ];
    };

    return (
        <div>
            <div className="text">
                Now we need to know about the ceiling of the space. Then
                you&apos;ll be all set to create your light masterpiece.
            </div>
            <div className="row">
                <FormControl className="col-sm-4" name="type" required>
                    <label className="selectLabel">
                        Ceiling Type<span className="asterisk">*</span>
                    </label>
                    <Select
                        searchable
                        value={formState.type}
                        onChange={({ value }) =>
                            !!value &&
                            changeFormState({
                                type: value,
                                ...Map.Collections.tileSizes["2x4"],
                            })
                        }
                        options={ceilingTypesOptions}
                    />
                </FormControl>
            </div>
            <div className="row">
                {formState.type === Map.Collections.ceilingTypes[0]
                    ? renderCeilingTileSizeSelect()
                    : renderCeilingTileSizeCustom()}
                <FormControl className="col-sm-3" name="gridOffSetX">
                    <Input
                        label="Grid Offset X"
                        value={formState.gridOffSetX}
                        onChange={(value) =>
                            changeFormState({
                                gridOffSetX: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
                <FormControl className="col-sm-3" name="gridOffSetY">
                    <Input
                        label="Grid Offset Y"
                        value={formState.gridOffSetY}
                        onChange={(value) =>
                            changeFormState({
                                gridOffSetY: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
            </div>
        </div>
    );
};

/**
 * Wizard step for the ceiling grid and tile dimensions.
 *
 * @param props - The settings step props, forwarded verbatim.
 * @returns The rendered ceiling step.
 */
const CeilingStep = (props) => (
    <SettingsStep {...props} renderFormControls={renderFormControls} />
);

export default CeilingStep;
